export const addedValueBehavioursQuery = `query AddedValueBehaviours($sessionId: String!, $input: HealthCare_GetAddedValueBehavioursRequestInput!) {
        addedValueBehaviours(sessionId: $sessionId, input: $input) {
          packageId
          fullZorgWebCode
          behaviours {
            code
            score
            title
            description
            components {
              name
              coverages {
                costTypeId
                costTypeUniqueTitle
                insuranceId
                coverageType
                contractCoverages {
                  isContracted
                  summary
                }
                expandedText
              }
              services {
                description
                extendedText
                variableValues {
                  variableName
                  value
                }
              }
              serviceCode
            }
          }
        }
      }`;
